import React, { useState, useEffect } from "react";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Button, Grid, makeStyles, Typography } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import { connect } from "react-redux";

import styles from "../../../styles/global-styles";
import { actions as actionsAlert } from "../../../redux/actions/alert";
import { SellService } from "../../../services/sell.service";
import { AuthService } from "../../../services/auth.service";
import { groupAccesoriesAndTotalSells } from "./utils_sells";

const useStyles = makeStyles(() => ({
  title: { color: "#1C2668", fontWeight: 600 },
  rightButton: styles.buttonRightHeader,
  chip: styles.chip,
  successfulChip: styles.successfullChip,
  secondaryChip: styles.secondaryChip,
  body: styles.body,
  subtitle: styles.subtitle,
}));

const SellsHeader = ({
  title,
  typeOfSells,
  addAlert,
  detailAlert,
  salesInfo,
}) => {
  const classes = useStyles();

  /** states */
  const [queryParams, setqueryParams] = useState({});
  const [sales, setSales] = useState({});
  const [startDate, setStartDate] = useState(
    moment().subtract(1, "days").startOf("day").format()
  );
  const [endDate, setEndDate] = useState(moment().endOf("day").format());
  const [_, setPage] = React.useState(0);

  useEffect(() => {
    const { siteId, id } = AuthService.currentUserValue;
    if (!!siteId && !!id) {
      setqueryParams({ ...queryParams, siteId, userId: id });
    } else {
      AuthService.logout();
    }
  }, []);

  useEffect(() => {
    if (Object.values(sales).length === 2) {
      const dates = { startDate, endDate };
      salesInfo(sales.totalSales, sales.salesArray, dates);
    }
    return () => {
      //console.log("component unmount");
    };
  }, [sales]);

  const handleStartChange = (date) =>
    setStartDate(moment(date).startOf("day").format());

  const handleEndChange = (date) =>
    setEndDate(moment(date).endOf("day").format());

  const searchProductByFilters = async () => {
    const utcStartDate = moment(startDate).utc().format();
    const utcEndDate = moment(endDate).utc().format();

    if (moment(endDate).isAfter(moment(startDate))) {
      //reset pagination to 0
      setPage(0);
      try {
        const body =
          typeOfSells === "sellsByUser"
            ? {
                ...queryParams,
                startDate: utcStartDate,
                endDate: utcEndDate,
              }
            : {
                siteId: queryParams.siteId,
                startDate: utcStartDate,
                endDate: utcEndDate,
              };

        const { data } = await SellService.getAllSellsWithParams(body);

        if (data.length) {
          setSales(groupAccesoriesAndTotalSells(data));
        } else {
          const error = {
            noData:
              "No se encontró ninguna venta(s) con las fechas seleccionadas",
          };
          throw error;
        }
      } catch (error) {
        console.log("error", error);
        addAlert({ showAlert: true });
        detailAlert({
          severity: error.noData ? "info" : "error",
          message: error.noData
            ? error.noData
            : error.msgs || "Error al recuperar las ventas de los productos",
          time: 3000,
        });
      }
    } else {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "warning",
        message: "La fecha de inicio es MAYOR a la fecha de fin",
      });
      return;
    }
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justify="flex-start"
        alignContent="center"
        spacing={3}
        // style={{ height: 90 }}
      >
        <Grid item>
          <Typography variant="h4" component="h4" className={classes.title}>
            {title}
          </Typography>
        </Grid>
        <Grid item>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <DatePicker
              style={{ marginRight: 40 }}
              disableToolbar
              variant="inline"
              format="DD/MM/yyyy"
              margin="normal"
              autoOk
              disableFuture
              label="Fecha de inicio"
              placeholder="20/02/2021"
              value={startDate}
              onChange={handleStartChange}
            />

            <DatePicker
              disableToolbar
              variant="inline"
              format="DD/MM/yyyy"
              margin="normal"
              autoOk
              placeholder="21/02/2021"
              disableFuture
              label="Fecha de fin"
              value={endDate}
              onChange={handleEndChange}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item>
          <Button
            className={classes.rightButton}
            variant="contained"
            disabled={false}
            onClick={searchProductByFilters}
            color="primary"
            endIcon={<SearchIcon color="secondary" />}
          >
            Filtrar
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

const dispatch = {
  detailAlert: actionsAlert.detailAlert,
  addAlert: actionsAlert.addAlert,
};

export default connect(null, dispatch)(SellsHeader);
